import { useQuery } from '@tanstack/react-query';
import { useAccessToken } from '@/auth/useAccessToken';
import { meApi, type Me } from './meApi';

/**
 * Fetches the signed-in user's profile + resolved role from /api/me once and
 * caches it. The role drives role-aware UI (e.g. the header badge, and IT-only
 * views as they land).
 */
export function useMe() {
  const getAccessToken = useAccessToken();
  return useQuery<Me>({
    queryKey: ['me'],
    queryFn: ({ signal }) => meApi.get(getAccessToken, signal),
    staleTime: 5 * 60_000
  });
}
